<div class="widget-container mb-3" *ngIf="data.length; else noDataTemplate">
	<sct-charts
		class="chart"
		[id]="title"
		[title]="title"
		[data]="chartData"
		[columnNames]="columnNames"
		[options]="config"
		[type]="'ColumnChart'"
		(select)="onSelectRange($event)"
	></sct-charts>
</div>

<app-modal [hasConfirmButton]="false" [hasCloseButton]="false" #popupModal [title]="title + ' (' + selectedRangeTitle + ')'" size="lg">
	<sct-custom-table
		*ngIf="tableData.length"
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</app-modal>

<ng-template #noDataTemplate class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>